var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMicrosoftOfficeCalendar = function SvgMicrosoftOfficeCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 45.2,
    y1: -1.42,
    x2: 45.2,
    y2: 57.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ef8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e25c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#db4401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d83b01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 34.52,
    y1: 0.67,
    x2: 3.16,
    y2: 45.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#800600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c72127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#c13959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#bc4b81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b95799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b85ba2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 18.5,
    y1: 55.63,
    x2: 59.44,
    y2: 55.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f32b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a4070a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 35.16,
    y1: -0.24,
    x2: 28.52,
    y2: 9.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 46.32,
    y1: 56.55,
    x2: 27.99,
    y2: 54.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_-_Color",
    "data-name": "Icons - Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_-_Full_Bleed",
    "data-name": "Desktop - Full Bleed"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.93 49a3.22 3.22 0 0 0-1.59 6l11.36 6.44a6.2 6.2 0 0 0 3.07.81 6 6 0 0 0 1.71-.25l17.09-4.87A6.12 6.12 0 0 0 56 51.26V49Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.93 49a3.22 3.22 0 0 0-1.59 6l11.36 6.44a6.2 6.2 0 0 0 3.07.81 6 6 0 0 0 1.71-.25l17.09-4.87A6.12 6.12 0 0 0 56 51.26V49Z",
    style: {
      opacity: 0.12,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.41 2 39 12.5V49l-4.52 13 17.09-4.87A6.12 6.12 0 0 0 56 51.26V12.74a6.11 6.11 0 0 0-4.44-5.88Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.74 48.61 5-2.7A4.36 4.36 0 0 0 20 42.08V22.43a4.37 4.37 0 0 1 2.87-4.1L39 12.5V8.07A6.32 6.32 0 0 0 34.41 2a6.18 6.18 0 0 0-1.73-.24 6.41 6.41 0 0 0-3.14.83L11.08 13.12A6.1 6.1 0 0 0 8 18.42v27.36a3.21 3.21 0 0 0 4.74 2.83Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 49H19.93a3.22 3.22 0 0 0-1.59 6l11.36 6.44a6.2 6.2 0 0 0 3.07.81 6 6 0 0 0 1.71-.25A6.22 6.22 0 0 0 39 56Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.74 48.61 5-2.7A4.36 4.36 0 0 0 20 42.08V22.43a4.37 4.37 0 0 1 2.87-4.1L39 12.5V8.07A6.32 6.32 0 0 0 34.41 2a6.18 6.18 0 0 0-1.73-.24 6.41 6.41 0 0 0-3.14.83L11.08 13.12A6.1 6.1 0 0 0 8 18.42v27.36a3.21 3.21 0 0 0 4.74 2.83Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 49H19.93a3.22 3.22 0 0 0-1.59 6l11.36 6.44a6.2 6.2 0 0 0 3.07.81 6 6 0 0 0 1.71-.25A6.22 6.22 0 0 0 39 56Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h64v64H0z"
  })))));
};

export { SvgMicrosoftOfficeCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjQgNjQiPgoJPGRlZnM+CgkJPHN0eWxlPgogICAgICAgIAkJLmNscy0xewoJCQkJCWlzb2xhdGlvbjppc29sYXRlOwoJCQkJfQoKCQkJCS5jbHMtMnsKCQkJCQlvcGFjaXR5OjAuMjsKCQkJCX0KCgkJCQkuY2xzLTIsLmNscy0zLC5jbHMtNXsKCQkJCQltaXgtYmxlbmQtbW9kZTptdWx0aXBseTsKCQkJCX0KCgkJCQkuY2xzLTR7CgkJCQkJZmlsbDojZmZmOwoJCQkJfQoKCQkJCS5jbHMtNXsKCQkJCQlvcGFjaXR5OjAuMTI7CgkJCQl9CgoJCQkJLmNscy02ewoJCQkJCWZpbGw6dXJsKCNsaW5lYXItZ3JhZGllbnQpOwoJCQkJfQoKCQkJCS5jbHMtN3sKCQkJCQlmaWxsOnVybCgjbGluZWFyLWdyYWRpZW50LTIpOwoJCQkJfQoKCQkJCS5jbHMtOHsKCQkJCQlmaWxsOnVybCgjbGluZWFyLWdyYWRpZW50LTMpOwoJCQkJfQoKCQkJCS5jbHMtOXsKCQkJCQlmaWxsOnVybCgjbGluZWFyLWdyYWRpZW50LTQpOwoJCQkJfQoKCQkJCS5jbHMtMTB7CgkJCQkJZmlsbDp1cmwoI2xpbmVhci1ncmFkaWVudC01KTsKCQkJCX0KCgkJCQkuY2xzLTExewoJCQkJCWZpbGw6bm9uZTsKCQkJCX0KCQk8L3N0eWxlPgoKCQk8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjQ1LjIiIHkxPSItMS40MiIgeDI9IjQ1LjIiIHkyPSI1Ny44IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmZiOTAwIi8+PHN0b3Agb2Zmc2V0PSIwLjE3IiBzdG9wLWNvbG9yPSIjZWY4NDAwIi8+PHN0b3Agb2Zmc2V0PSIwLjMxIiBzdG9wLWNvbG9yPSIjZTI1YzAxIi8+PHN0b3Agb2Zmc2V0PSIwLjQzIiBzdG9wLWNvbG9yPSIjZGI0NDAxIi8+PHN0b3Agb2Zmc2V0PSIwLjUiIHN0b3AtY29sb3I9IiNkODNiMDEiLz48L2xpbmVhckdyYWRpZW50PgoJCTxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50LTIiIHgxPSIzNC41MiIgeTE9IjAuNjciIHgyPSIzLjE2IiB5Mj0iNDUuNDUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM4MDA2MDAiLz48c3RvcCBvZmZzZXQ9IjAuNiIgc3RvcC1jb2xvcj0iI2M3MjEyNyIvPjxzdG9wIG9mZnNldD0iMC43MyIgc3RvcC1jb2xvcj0iI2MxMzk1OSIvPjxzdG9wIG9mZnNldD0iMC44NSIgc3RvcC1jb2xvcj0iI2JjNGI4MSIvPjxzdG9wIG9mZnNldD0iMC45NCIgc3RvcC1jb2xvcj0iI2I5NTc5OSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2I4NWJhMiIvPjwvbGluZWFyR3JhZGllbnQ+CgkJPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQtMyIgeDE9IjE4LjUiIHkxPSI1NS42MyIgeDI9IjU5LjQ0IiB5Mj0iNTUuNjMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmMzJiNDQiLz48c3RvcCBvZmZzZXQ9IjAuNiIgc3RvcC1jb2xvcj0iI2E0MDcwYSIvPjwvbGluZWFyR3JhZGllbnQ+CgkJPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQtNCIgeDE9IjM1LjE2IiB5MT0iLTAuMjQiIHgyPSIyOC41MiIgeTI9IjkuMjQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3Atb3BhY2l0eT0iMC40Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLW9wYWNpdHk9IjAiLz48L2xpbmVhckdyYWRpZW50PgoJCTxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50LTUiIHgxPSI0Ni4zMiIgeTE9IjU2LjU1IiB4Mj0iMjcuOTkiIHkyPSI1NC45NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1vcGFjaXR5PSIwLjQiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3Atb3BhY2l0eT0iMCIvPjwvbGluZWFyR3JhZGllbnQ+CiAgCTwvZGVmcz4KICAKIDxnIGNsYXNzPSJjbHMtMSI+Cgk8ZyBpZD0iSWNvbnNfLV9Db2xvciIgZGF0YS1uYW1lPSJJY29ucyAtIENvbG9yIj4KCQk8ZyBpZD0iRGVza3RvcF8tX0Z1bGxfQmxlZWQiIGRhdGEtbmFtZT0iRGVza3RvcCAtIEZ1bGwgQmxlZWQiPgoJCQk8ZyBjbGFzcz0iY2xzLTIiPgoJCQkJPHBhdGggY2xhc3M9ImNscy00IiBkPSJNMTkuOTMsNDlhMy4yMiwzLjIyLDAsMCwwLTEuNTksNkwyOS43LDYxLjQ0YTYuMiw2LjIsMCwwLDAsMy4wNy44MUE2LDYsMCwwLDAsMzQuNDgsNjJsMTcuMDktNC44N0E2LjEyLDYuMTIsMCwwLDAsNTYsNTEuMjZWNDlaIi8+CiAgICAgICAgICAJPC9nPgoKICAgICAgICAgIAk8ZyBjbGFzcz0iY2xzLTUiPgoJCQkJPHBhdGggY2xhc3M9ImNscy00IiBkPSJNMTkuOTMsNDlhMy4yMiwzLjIyLDAsMCwwLTEuNTksNkwyOS43LDYxLjQ0YTYuMiw2LjIsMCwwLDAsMy4wNy44MUE2LDYsMCwwLDAsMzQuNDgsNjJsMTcuMDktNC44N0E2LjEyLDYuMTIsMCwwLDAsNTYsNTEuMjZWNDlaIi8+CiAgICAgICAgIAk8L2c+CgkJCQk8cGF0aCBjbGFzcz0iY2xzLTYiIGQ9Ik0zNC40MSwyLDM5LDEyLjVWNDlMMzQuNDgsNjJsMTcuMDktNC44N0E2LjEyLDYuMTIsMCwwLDAsNTYsNTEuMjZWMTIuNzRhNi4xMSw2LjExLDAsMCwwLTQuNDQtNS44OFoiLz4KCQkJCTxwYXRoIGNsYXNzPSJjbHMtNyIgZD0iTTEyLjc0LDQ4LjYxbDUtMi43QTQuMzYsNC4zNiwwLDAsMCwyMCw0Mi4wOFYyMi40M2E0LjM3LDQuMzcsMCwwLDEsMi44Ny00LjFMMzksMTIuNVY4LjA3QTYuMzIsNi4zMiwwLDAsMCwzNC40MSwyYTYuMTgsNi4xOCwwLDAsMC0xLjczLS4yNGgwYTYuNDEsNi40MSwwLDAsMC0zLjE0LjgzTDExLjA4LDEzLjEyQTYuMSw2LjEsMCwwLDAsOCwxOC40MlY0NS43OEEzLjIxLDMuMjEsMCwwLDAsMTIuNzQsNDguNjFaIi8+CgkJCQk8cGF0aCBjbGFzcz0iY2xzLTgiIGQ9Ik0zOSw0OUgxOS45M2EzLjIyLDMuMjIsMCwwLDAtMS41OSw2TDI5LjcsNjEuNDRhNi4yLDYuMiwwLDAsMCwzLjA3LjgxaDBBNiw2LDAsMCwwLDM0LjQ4LDYyLDYuMjIsNi4yMiwwLDAsMCwzOSw1NloiLz4KCQkJCTxwYXRoIGNsYXNzPSJjbHMtOSIgZD0iTTEyLjc0LDQ4LjYxbDUtMi43QTQuMzYsNC4zNiwwLDAsMCwyMCw0Mi4wOFYyMi40M2E0LjM3LDQuMzcsMCwwLDEsMi44Ny00LjFMMzksMTIuNVY4LjA3QTYuMzIsNi4zMiwwLDAsMCwzNC40MSwyYTYuMTgsNi4xOCwwLDAsMC0xLjczLS4yNGgwYTYuNDEsNi40MSwwLDAsMC0zLjE0LjgzTDExLjA4LDEzLjEyQTYuMSw2LjEsMCwwLDAsOCwxOC40MlY0NS43OEEzLjIxLDMuMjEsMCwwLDAsMTIuNzQsNDguNjFaIi8+CgkJCQk8cGF0aCBjbGFzcz0iY2xzLTEwIiBkPSJNMzksNDlIMTkuOTNhMy4yMiwzLjIyLDAsMCwwLTEuNTksNkwyOS43LDYxLjQ0YTYuMiw2LjIsMCwwLDAsMy4wNy44MWgwQTYsNiwwLDAsMCwzNC40OCw2Miw2LjIyLDYuMjIsMCwwLDAsMzksNTZaIi8+CgkJCQk8cmVjdCBjbGFzcz0iY2xzLTExIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==";